import React from 'react'
import '../Styles/contactos.css'

const Contactos = () => {
    return (
        
            <div className="cards"id="CONTACTOS">
                <div className="services">
                    <div className="content content-1">
                        <div className="fab fa-whatsapp"></div>
                    <h2>Whatsapp</h2>
                    <p>Llamanos o Escribenos</p>
                    <a href="https://wa.me/593967752069?text=Necesito%20informacion%20sobre%20los%20productos%bepack"> 0967752069</a>
                    </div>
                    <div className="content content-3">
                        <div className="fab fa-google-plus"></div>
                        <h2>Gmail</h2>
                        <p>Escribenos Te esperamos</p>
                        <label htmlFor="1">bepacksolution@gmail.com</label>
                      
                    </div>
                
                    <div className="content content-3">
                        <div className="fab fa-facebook"></div>
                        <h2>Facebook</h2>
                        <p>Visitanos en nuestra pagina de Facebook official</p>
                        <a href="https://www.facebook.com/BePack-111811073930872">Contactanos</a>
                    </div>
                </div>
            </div>
       
    )
}

export default Contactos
